import { useState, useEffect } from "react";

function RSVPContactInfo() {
  const [responses, setResponses] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const [attendWedding, setAttendWedding] = useState("");
  const [attendWelcomeParty, setAttendWelcomeParty] = useState("");

  // ✅ COLUMN TOGGLES (added gift)
  const [columns, setColumns] = useState({
    guests: true,
    email: true,
    phone: true,
    gift: true,
  });

  useEffect(() => {
    fetchData();
  }, [attendWedding, attendWelcomeParty]);

  async function fetchData() {
    setPageLoading(true);
    setLoadingError(false);

    try {
      const params = new URLSearchParams();

      if (attendWedding !== "") {
        params.append("attend_wedding", attendWedding);
      }

      if (attendWelcomeParty !== "") {
        params.append("attend_welcome_party", attendWelcomeParty);
      }

      const url = `https://wedding-website-backend-nu.vercel.app/api/responses${params.toString() ? `?${params.toString()}` : ""
        }`;

      const res = await fetch(url);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      setResponses(data.responses);
    } catch (err) {
      console.error(err);
      setLoadingError(true);
    } finally {
      setPageLoading(false);
    }
  }

  const getGuestNames = (guests) => {
    return guests.map((g) => g.name).join(", ");
  };

  const toggleColumn = (key) => {
    setColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="text-center rounded border p-2">
      <div className="subheading text-rose mb-4 text-2xl">
        Contact Information
      </div>

      {/* Filters */}
      <div className="flex gap-4 justify-center mb-4 text-sm">
        <div>
          <label className="block mb-1">Wedding</label>
          <select
            value={attendWedding}
            onChange={(e) => setAttendWedding(e.target.value)}
            className="border p-1"
          >
            <option value="">All</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>

        <div>
          <label className="block mb-1">Welcome Party</label>
          <select
            value={attendWelcomeParty}
            onChange={(e) => setAttendWelcomeParty(e.target.value)}
            className="border p-1"
          >
            <option value="">All</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </div>
      </div>

      {/* COLUMN TOGGLES */}
      <div className="flex justify-center gap-4 mb-4 text-xs">
        <label>
          <input
            type="checkbox"
            checked={columns.guests}
            onChange={() => toggleColumn("guests")}
            className="mr-1"
          />
          Show Guests
        </label>

        <label>
          <input
            type="checkbox"
            checked={columns.email}
            onChange={() => toggleColumn("email")}
            className="mr-1"
          />
          Show Email
        </label>

        <label>
          <input
            type="checkbox"
            checked={columns.phone}
            onChange={() => toggleColumn("phone")}
            className="mr-1"
          />
          Show Phone
        </label>

        <label>
          <input
            type="checkbox"
            checked={columns.gift}
            onChange={() => toggleColumn("gift")}
            className="mr-1"
          />
          Show Gift
        </label>
      </div>

      {/* States */}
      {pageLoading && <p>Loading...</p>}
      {loadingError && (
        <p className="text-red-400">Failed to fetch responses</p>
      )}

      {/* Table */}
      {!pageLoading && !loadingError && (
        <div className="space-y-2">
          <ul>
            <li className="border px-2 bg-rose text-white">
              <div className="flex items-center w-full p-1 text-xs">
                {columns.guests && (
                  <div className="flex-[2_2_0%] px-1">Guests</div>
                )}
                {columns.email && (
                  <div className="flex-1 px-1">Email</div>
                )}
                {columns.phone && (
                  <div className="flex-1 px-1">Phone</div>
                )}
                {columns.gift && (
                  <div className="flex-1 px-1">Gift</div>
                )}
              </div>
            </li>
          </ul>

          <ul className="scroll-box space-y-2 max-h-96 overflow-y-auto">
            {responses.map((res) => (
              <li key={res._id} className="border p-2">
                <div className="flex text-xs w-full">
                  {columns.guests && (
                    <div className="flex-[2_2_0%] px-1">
                      {getGuestNames(res.guests)}
                    </div>
                  )}

                  {columns.email && (
                    <div className="flex-1 px-1 break-all">
                      {res.email}
                    </div>
                  )}

                  {columns.phone && (
                    <div className="flex-1 px-1">
                      {res.phone || "—"}
                    </div>
                  )}

                  {columns.gift && (
                    <div className="flex-1 px-1">
                      {res.gift || "—"}
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default RSVPContactInfo;
// import { useState, useEffect } from "react";

// function RSVPContactInfo() {
//   const [responses, setResponses] = useState([]);
//   const [pageLoading, setPageLoading] = useState(true);
//   const [loadingError, setLoadingError] = useState(false);

//   const [attendWedding, setAttendWedding] = useState("");
//   const [attendWelcomeParty, setAttendWelcomeParty] = useState("");

//   // ✅ COLUMN TOGGLES
//   const [columns, setColumns] = useState({
//     guests: true,
//     email: true,
//     phone: true,
//   });

//   useEffect(() => {
//     fetchData();
//   }, [attendWedding, attendWelcomeParty]);

//   async function fetchData() {
//     setPageLoading(true);
//     setLoadingError(false);

//     try {
//       const params = new URLSearchParams();

//       if (attendWedding !== "") {
//         params.append("attend_wedding", attendWedding);
//       }

//       if (attendWelcomeParty !== "") {
//         params.append("attend_welcome_party", attendWelcomeParty);
//       }

//       const url = `https://wedding-website-backend-nu.vercel.app/api/responses${
//         params.toString() ? `?${params.toString()}` : ""
//       }`;

//       const res = await fetch(url);

//       if (!res.ok) {
//         throw new Error(`HTTP error! status: ${res.status}`);
//       }

//       const data = await res.json();
//       setResponses(data.responses);
//     } catch (err) {
//       console.error(err);
//       setLoadingError(true);
//     } finally {
//       setPageLoading(false);
//     }
//   }

//   const getGuestNames = (guests) => {
//     return guests.map((g) => g.name).join(", ");
//   };

//   const toggleColumn = (key) => {
//     setColumns((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   return (
//     <div className="text-center rounded border p-2">
//       <div className="subheading text-rose mb-4 text-2xl">
//         Contact Information
//       </div>

//       {/* Filters */}
//       <div className="flex gap-4 justify-center mb-4 text-sm">
//         <div>
//           <label className="block mb-1">Wedding</label>
//           <select
//             value={attendWedding}
//             onChange={(e) => setAttendWedding(e.target.value)}
//             className="border p-1"
//           >
//             <option value="">All</option>
//             <option value="true">Yes</option>
//             <option value="false">No</option>
//           </select>
//         </div>

//         <div>
//           <label className="block mb-1">Welcome Party</label>
//           <select
//             value={attendWelcomeParty}
//             onChange={(e) => setAttendWelcomeParty(e.target.value)}
//             className="border p-1"
//           >
//             <option value="">All</option>
//             <option value="true">Yes</option>
//             <option value="false">No</option>
//           </select>
//         </div>
//       </div>

//       {/* ✅ COLUMN TOGGLES */}
//       <div className="flex justify-center gap-4 mb-4 text-xs">
//         <label>
//           <input
//             type="checkbox"
//             checked={columns.guests}
//             onChange={() => toggleColumn("guests")}
//             className="mr-1"
//           />
//           Show Guests
//         </label>

//         <label>
//           <input
//             type="checkbox"
//             checked={columns.email}
//             onChange={() => toggleColumn("email")}
//             className="mr-1"
//           />
//           Show Email
//         </label>

//         <label>
//           <input
//             type="checkbox"
//             checked={columns.phone}
//             onChange={() => toggleColumn("phone")}
//             className="mr-1"
//           />
//           Show Phone
//         </label>
//       </div>

//       {/* States */}
//       {pageLoading && <p>Loading...</p>}
//       {loadingError && (
//         <p className="text-red-400">Failed to fetch responses</p>
//       )}

//       {/* Table */}
//       {!pageLoading && !loadingError && (
//         <div className="space-y-2">
//           <ul>
//             <li className="border px-2 bg-rose text-white">
//               <div className="flex items-center w-full p-1 text-xs">
//                 {columns.guests && (
//                   <div className="flex-[2_2_0%] px-1">Guests</div>
//                 )}
//                 {columns.email && (
//                   <div className="flex-1 px-1">Email</div>
//                 )}
//                 {columns.phone && (
//                   <div className="flex-1 px-1">Phone</div>
//                 )}
//               </div>
//             </li>
//           </ul>

//           <ul className="scroll-box space-y-2 max-h-96 overflow-y-auto">
//             {responses.map((res) => (
//               <li key={res._id} className="border p-2">
//                 <div className="flex text-xs w-full">
//                   {columns.guests && (
//                     <div className="flex-[2_2_0%] px-1">
//                       {getGuestNames(res.guests)}
//                     </div>
//                   )}

//                   {columns.email && (
//                     <div className="flex-1 px-1 break-all">
//                       {res.email}
//                     </div>
//                   )}

//                   {columns.phone && (
//                     <div className="flex-1 px-1">
//                       {res.phone || "—"}
//                     </div>
//                   )}
//                 </div>
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}
//     </div>
//   );
// }

// export default RSVPContactInfo;